require('./resizeConfig');

angular.module('app.shared.resize.resizeService', [
  'app.shared.resize.RESIZE_CONFIG'
])
  .service('app.shared.resize.resizeService', [
    '$window',
    '$document',
    'RESIZE_CONFIG',
    function ($window, $document, RESIZE_CONFIG) {
      "use strict";

      function getTarget(width) {
        let target;
        for (let k in RESIZE_CONFIG.TARGET_SIZES) {
          if (RESIZE_CONFIG.TARGET_SIZES.hasOwnProperty(k)) {
            if (width < RESIZE_CONFIG.TARGET_SIZES[k]) {
              target = k;
            }
          }
        }
        return target;
      }

      return {
        getSize: function (element) {
          return {
            width: element.width(),
            height: element.height(),
            target: getTarget($window.innerWidth || $document[0].body.clientWidth)
          };
        }
      };
    }]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/resize/resizeService.js